/**
 * src/lib/api/focusPins.js — TICKET-209 P3 Focus Pins client API
 */
import { apiFetch, API_BASE } from './client';

const DATA = `${API_BASE}/data`;

/** Fetch all active focus pins for the current user. */
export async function fetchMyPins() {
  const data = await apiFetch(`${DATA}?action=focus.list`);
  return data?.pins || [];
}

/** Pin a project to a teammate's Focus feed. */
export async function pinProject(projectId, userId, note = '') {
  return apiFetch(DATA, {
    method: 'POST',
    body: JSON.stringify({ action: 'focus.pin', project_id: projectId, user_id: userId, note }),
  });
}

/** Pin a deal to a teammate's Focus feed. */
export async function pinDeal(dealId, userId, note = '') {
  return apiFetch(DATA, {
    method: 'POST',
    body: JSON.stringify({ action: 'focus.pin', deal_id: dealId, user_id: userId, note }),
  });
}

/** Soft-archive a focus pin (remove from teammate's feed). */
export async function unpin(pinId) {
  return apiFetch(DATA, {
    method: 'POST',
    body: JSON.stringify({ action: 'focus.unpin', id: pinId }),
  });
}
